import { useEffect, useRef } from "react";

export const usePowerBITokenRefresh = ({
  reportRef,
  getNewToken,
  tokenExpiryTime, // optional
}) => {
  const timeoutRef = useRef(null);
  //  Refresh token
  const refreshToken = async () => {
    try {
      const res = await getNewToken();

      const newToken = res?.token;
      const newExpiry = res?.expiry;

      if (reportRef.current && newToken) {
        await reportRef.current.setAccessToken(newToken);
      }

      // reschedule next refresh
      if (newExpiry) {
        scheduleRefresh(newExpiry);
      }
    } catch (err) {
      console.error(" Token refresh failed", err);
    }
  };

  //  Schedule refresh before expiry
  const scheduleRefresh = (expiryTime) => {
    if (!expiryTime) return;

    const now = Date.now();
    const expiryMs =
    typeof expiryTime === 'string'
      ? new Date(expiryTime).getTime()
      : expiryTime;
    const buffer = 5 * 60 * 1000; // 5 min before expiry
    const delay = expiryMs - now - buffer; 
    console.log( delay, "checkexpiryMs")

    if (delay <= 0) {
      refreshToken();
      return;
    }

    timeoutRef.current = setTimeout(() => {
      refreshToken();
    }, delay);
  };

  // setup initial timer
  useEffect(() => {
    if (tokenExpiryTime) {
      scheduleRefresh(tokenExpiryTime);
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [tokenExpiryTime]);

  //  fallback: refresh on error
  const handleError = async (event) => {
    const msg = event?.detail?.message?.toLowerCase();

    if (msg?.includes("token") || msg?.includes("expired")) {
      console.warn(" Token expired → refreshing...");
      await refreshToken();
    }
  };

  return { handleError };
};